import React from 'react';

import { SearchLinkSkeleton } from './search-link-skeleton';
export const SearchLinkSkeletons = () => {
	return (
		<>
			<SearchLinkSkeleton />
			<SearchLinkSkeleton />
			<SearchLinkSkeleton />
			<SearchLinkSkeleton />
			<SearchLinkSkeleton />
		</>
	);
};
